import React from 'react'
import Index from './Index'
export function MainDashboard() {
    return (
        <div>
            <Index />
        </div>
    )
}
export function ProjectsDashboard() {
    return (
        <div>
            projects(coming soon)
        </div>
    )
}
export function TeamsDashboard() {
    return (
        <div>
            teams (coming soon)
        </div>
    )
}
export function PersonalDashboard() {
    return (
        <div>
            personal(coming soon)
        </div>
    )
}
export function BusinessDashboard() {
    return (
        <div>
            business (coming soon)
        </div>
    )
}

